<ion-tab-bar slot="bottom" class="custom-tab-bar">
  @for (tab of tabs; track tab.id) {
    <ion-tab-button
      [tab]="tab.route"
      [href]="tab.route"
      [selected]="activeTabId === tab.id"
      [attr.aria-label]="tab.label"
      (click)="onTabClick(tab, $event)"
    >
      <!-- Pílula atrás do ícone indica a aba ativa -->
      <span class="tab-pill">
        @if (tab.id === 'student-profile' && profileImageUrl) {
          <ion-avatar class="tab-profile-avatar">
            <img [src]="profileImageUrl" alt="" referrerpolicy="no-referrer" />
          </ion-avatar>
        } @else {
          <ion-icon
            class="tab-icon"
            [name]="activeTabId === tab.id && tab.iconSelected ? tab.iconSelected : tab.icon"
            aria-hidden="true">
          </ion-icon>
        }
        @if (isChatTab(tab) && unreadChatCount > 0) {
          <span class="tab-badge" [attr.aria-label]="unreadChatCount + ' conversas não lidas'">
            {{ unreadChatCount > 9 ? '9+' : unreadChatCount }}
          </span>
        }
      </span>
      <ion-label class="tab-label">{{ tab.label }}</ion-label>
    </ion-tab-button>
  }
</ion-tab-bar>
